import axios from "axios"
import library from "../../../utils/Library"

export const getAllSuborganizationGroupCorpEntity = async () => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("suborganizations") +
    "/getAllSuborganizationGroupCorpEntity"

  return await axios({
    url: URL,
    method: "POST",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
